// APIのレスポンスの型
export type ApiResult = ApiSuccessResult | ApiErrorResult;

// 正常時の型
export type ApiSuccessResult = {
  data: any;
  ok: true;
};

// 異常時の型
export type ApiErrorResult = {
  data: { code?: number; message: string; };
  ok: false;
};

// セッションタイムアウトエラー
export class timeoutError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

interface httpRequestOption{
    success:(data:any) => void,
    timeout:() => void,
    error:(code:number ,message:string) => void,
}
// 未ログイン
const STATUS_ERR_NO_LOGIN:number = -5000;
// ログインページへ
const STATUS_NO_LOGIN_REDIRECT:number = -5100;

/**
 * API呼び出し処理
 * @param response 
 * @returns 
 */
const handleResponse = async (response: Response): Promise<ApiResult> => {
    const data:any = await response.json();
    if (!response.ok) { 
        return {
            ok: false,
            data: {
              message: response.statusText,
              code: response.status,
            },
        };
    }
    // 正常終了
    return { ok: true, data };
};

/**
 * 
 * @param url 
 * @param init 
 * @returns 
 */
const http = async (url: string, init?: RequestInit): Promise<Response> => {
    const response = await fetch(url, init);
    return response;
};

/**
 *  GETリクエスト
 */ 
export const httpGet = async (url: string ,option:httpRequestOption) => {
    const data = await http(url, {
      method: 'GET',
      mode: 'cors',
      credentials:'include',
      headers:{'X-Requested-With': 'XMLHttpRequest'},
    });
    const ret = await handleResponse(data);
    if(ret.ok){
      if(ret.data.status == STATUS_ERR_NO_LOGIN || ret.data.status == STATUS_NO_LOGIN_REDIRECT){
        // 未ログイン、または、ログインページへ遷移の場合
        option.timeout();
      }else{
        option.success(ret.data);
      }
    }
    else
        option.error(ret.data.code ,ret.data.message);
};
  
/**
 * POSTリクエスト
 * @param url 
 * @param form 
 * @returns 
 */
export const httpPost = async (
    url: string,
    form: FormData,
    option:httpRequestOption
) => {
    const data = await http(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers:{'X-Requested-With': 'XMLHttpRequest'},
      body: form,
    });
    const ret =  await handleResponse(data);
    if(ret.ok){
      if(ret.data.status == STATUS_ERR_NO_LOGIN || ret.data.status == STATUS_NO_LOGIN_REDIRECT){
        // 未ログイン、または、ログインページへ遷移の場合
        option.timeout();
      }else{
        option.success(ret.data);
      }
    }
    else
        option.error(ret.data.code ,ret.data.message);
};